import type { RiskResponse } from '@/lib/types';

interface Props {
  data: RiskResponse | undefined;
  loading: boolean;
}

export function RiskList({ data, loading }: Props) {
  const items = data?.items ?? [];
  const total = data?.total ?? 0;

  return (
    <section className="panel">
      <header className="flex items-baseline justify-between border-b border-ink-800 px-6 py-4">
        <div>
          <div className="label">Licencia sin uso 30d</div>
          <h2 className="mt-1 text-lg font-light text-ink-50">
            Candidatos a revocar
          </h2>
        </div>
        <div className="text-xs text-ink-500">{total} en total</div>
      </header>
      {loading && items.length === 0 ? (
        <div className="py-10 text-center text-ink-500">Cargando…</div>
      ) : items.length === 0 ? (
        <div className="py-10 text-center text-ink-500">
          Nadie con licencia inactiva — perfecto
        </div>
      ) : (
        <ul>
          {items.map((u) => (
            <li
              key={u.upn}
              className="flex items-center justify-between border-t border-ink-800/60 px-6 py-3"
            >
              <div className="min-w-0">
                <div className="truncate text-sm text-ink-100">{u.full_name}</div>
                <div className="truncate text-xs text-ink-500">{u.upn}</div>
              </div>
              <div className="flex items-center gap-6 text-xs text-ink-400">
                <span className="hidden sm:block">{u.business_line ?? '—'}</span>
                <span className="hidden md:block">{u.department ?? '—'}</span>
                <span className="tabular-nums">
                  desde {u.license_assigned_at ?? '—'}
                </span>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
